import React, { Component } from 'react'
import SearchBar from './SearchBar'
import List from './List'
import { Provider } from 'mobx-react'
import Store from './store'
import NewView from '@common/NewView'
import { Button } from 'hljd'
import TemplateModal from './TemplateModal'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    return (
      <Provider store={this.store}>
        <NewView
          title="微传单+"
          extra={
            <Button type="primary" onClick={this.store.createActivity}>
              创建活动
            </Button>
          }
        >
          <SearchBar />
          <List />

          <TemplateModal store={this.store} />
        </NewView>
      </Provider>
    )
  }
}
